import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "cookie_consent";

type ConsentValue = "accepted" | "declined";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (!stored) {
      setVisible(true);
    }
  }, []);

  const handleChoice = (choice: ConsentValue) => {
    window.localStorage.setItem(STORAGE_KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="banner"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border/70 bg-card/95 px-4 py-4 shadow-card backdrop-blur-sm md:px-6 md:py-5"
    >
      <div className="container mx-auto flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <p className="text-[14px] leading-relaxed text-foreground md:text-[15px]">
          We use cookies to improve your experience and analyze site traffic. By continuing to use this site, you agree to our use of cookies and our{" "}
          <Link to="/privacy-policy" className="whitespace-nowrap font-medium text-primary underline-offset-2 hover:underline">
            Privacy Policy
          </Link>
          .
        </p>
        <div className="flex shrink-0 items-center gap-3">
          <Button
            variant="outline"
            size="sm"
            className="text-[14px]"
            onClick={() => handleChoice("declined")}
          >
            Decline
          </Button>
          <Button
            size="sm"
            className="text-[14px]"
            onClick={() => handleChoice("accepted")}
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
